import { render, staticRenderFns } from "./DisbursementDetail.vue?vue&type=template&id=055ec7cd&scoped=true&"
import script from "./DisbursementDetail.vue?vue&type=script&lang=js&"
export * from "./DisbursementDetail.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementDetail.vue?vue&type=style&index=0&id=055ec7cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ec7cd",
  null
  
)

export default component.exports